<template>
    <div class="liftRelayBox">
        <div class="liftRelayContent">
            <div class="liftRelayItem">
                <label :title="$t('LiftEnable')">{{$t('LiftEnable')}}</label>
                <el-switch
                v-model="floorEnable"
                :active-value="1"
                :inactive-value="0"
                >
                </el-switch>
            </div>
            <div v-show="floorEnable" class="liftRelayItem">
                <label :title="$t('RelayQuantity')">{{$t('RelayQuantity')}}</label>
                <el-input v-model="floorQuantity" @input="validatefloorQuantity" class="editInput" placeholder="1-128"></el-input>
                <el-button type="primary" @click="checkfloorQuantity" v-show="updateBlocks.showConfirmBtn">{{$t('Confirm')}}</el-button>
            </div>
            <div v-show="floorEnable" class="relayBox">
                <div class="relayItemBox" v-for="(item,index) in floorQuantityObj" :key="item.id">
                    <label :title="$t('Relay') + ' ' + (index+1)">{{$t('Relay') + ' ' + (index+1)}}</label>
                    <el-input v-model="item.name" @change="checkRelayInput" :disabled='updateBlocks.showConfirmBtn' class="relayItemInput">{{item.name}}</el-input>
                </div>
            </div>
            <el-button class="savetBtn" :loading="updateBlocks.updateBtnState == 1" @click="saveLiftRelay">{{$t('Save')}}</el-button>
        </div>
    </div>
  
</template>

<script>
import {nanoid} from 'nanoid'
import { mapState } from 'vuex';
import sitesBlocksApi from '@/api/blocks/index.js'
export default {
    name:"LiftRelay",
    data(){
        return{
           updateBlocks:{
            id:"",
            // name:"",
            // number:"",
            showConfirmBtn:false,
            updateBtnState:0,
           },
           floorEnable:1,
           floorQuantity:"12",
           floorQuantityObj:[],
           floorConfig: {},
        }
    },
    mounted(){
        this.updateBlocks.id = this.$route.params.id;
        //获取Blocks详情
        this.getBlocksDetail();
    },
    methods:{
        //获取Lift Relay详情
        getBlocksDetail(){
            let blocksObj = {
                "rgn":this.selectCompany.companyRegion,
                "id":this.updateBlocks.id
            }
            // 刷新时，apartmentid丢失，这里做个规避
            if(this.updateBlocks.id === undefined){
                return false
            }
            sitesBlocksApi.detailSiteBlocks(blocksObj).then(res => {
                if(res.code === 0){
                //    this.updateBlocks.name = res.data.apartmentName;
                //    this.updateBlocks.number = res.data.apartmentNo;
                   this.floorEnable = res.data.floorEnable;
                   this.floorQuantity = res.data.floorQuantity;
                   this.floorConfig = res.data.floorConfig;
                   //根据floorQuantity数和floorConfig生成floorQuantityObj
                    if(this.floorQuantity != 0 && this.floorQuantity != undefined && this.floorQuantity != null){
                        // 
                        this.floorQuantityObj = [];
                        for(let i = 0;i < this.floorQuantity; i++){
                            this.floorQuantityObj.push({
                                id:nanoid(),
                                name:''
                            })
                        }
                    }else{
                        this.floorQuantityObj = [];
                    }
                    if(this.floorConfig != undefined && this.floorConfig != null){
                        for(let k in this.floorConfig){
                            this.floorQuantityObj[k-1].name = this.floorConfig[k];
                        }
                    }
                    
                }else{
                    this.$handerrcode(res.code);
                    this.floorEnable = 0;
                    this.floorQuantity = '';
                    this.floorConfig = {};
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        //校验checkfloorQuantity是否输入正确
        validatefloorQuantity() {
            // 只允许输入数字
            this.floorQuantity = this.floorQuantity.replace(/[^\d]/g, '');
            
            // 不能以0开头
            // if (this.floorQuantity.startsWith('0') && this.floorQuantity !== '0') {
            //     this.floorQuantity = ''; // 清空输入框
            //     return;
            // }

            // 不能以0开头
            if (this.floorQuantity == 0) {
                this.floorQuantity = '';
                return false
            }
            // 空
            if (this.floorQuantity === '') {
                this.floorQuantity = ''
                this.updateBlocks.showConfirmBtn = true;
                return false
            }
            // 如果输入的数字大于128，截取为128
            if (this.floorQuantity && Number(this.floorQuantity) > 128) {
                this.floorQuantity = '128';
            }
            this.updateBlocks.showConfirmBtn = true;
        },
        //点击确认执行函数
        checkfloorQuantity(){
            this.updateBlocks.showConfirmBtn = false;
            this.floorQuantityObj = [];
            for(let i = 0;i < this.floorQuantity; i++){
                this.floorQuantityObj.push({
                    id:nanoid(),
                    name:''
                })
            }
            for(let k in this.floorConfig){
                if(!this.floorQuantityObj[k-1]){
                    break
                }
                this.floorQuantityObj[k-1].name = this.floorConfig[k]
            }
        },
        //校验checkRelayInput是否输入正确
        checkRelayInput(val){
            // 允许数字和字母混合，但只有数字部分可以有负号
            const regexRelay = /^-?\d+[a-zA-Z]*$|^[a-zA-Z]+\d*$|^-?\d+[a-zA-Z]+\d*$/;
            let regRelay = regexRelay.test(val);
            if(val === ""){
                return false
            }
            if(!regRelay){
                this.$message.info(this.$t('RelayLimit'));
                return false
            }
        },
        //更新Lift Relay
        saveLiftRelay(){
            // 允许数字和字母混合，但只有数字部分可以有负号
            const regexRelay = /^-?\d+[a-zA-Z]*$|^[a-zA-Z]+\d*$|^-?\d+[a-zA-Z]+\d*$/;
            //判断继电器名称是否合法
            let regRelayFlag = false;
            for (let i = 0; i < this.floorQuantityObj.length; i++) {
                if (this.floorQuantityObj[i].name != '' && !regexRelay.test(this.floorQuantityObj[i].name)){
                    regRelayFlag = true;
                    break
                } 
            }
            if(regRelayFlag){
                this.$message.info(this.$t('RelayLimit'));
                return false
            }
            for (let i = 0; i < this.floorQuantityObj.length; i++) {
                if (this.floorQuantityObj[i].name != ''){
                    let checkResultRelayNam = this.$regularCheckLimit(this.floorQuantityObj[i].name.trim(),1,20,'RelayLengthLimit');
                    if(!checkResultRelayNam){
                        return false
                    }
                } 
            }
            let finFloorConfig = {};
            this.floorQuantityObj.map((item,index) => {
                if(item.name != ""){
                    finFloorConfig[index+1] = item.name;
                }
            })
            if(this.floorEnable){
                if(this.floorQuantity === '' || this.floorQuantity === null){
                    this.$message.info(this.$t('RelayQuantityEmpty'));
                    return false
                }
                if(finFloorConfig && Object.keys(finFloorConfig).length === 0){
                    this.$message.info(this.$t('RelayConfigurationEmpty'));
                    return false
                }
            }else{
                this.floorEnable = 0;
                this.floorQuantity = "";
                finFloorConfig = {};
            }
           
            //判断继电器名称是否有重复
            // let relayNameArr = [];
            // for(let k in finFloorConfig){
            //     relayNameArr.push(finFloorConfig[k])
            // }
            // console.log("relayNameArr",relayNameArr);
            // console.log("relayName Repeat",new Set(relayNameArr).size !== relayNameArr.length)
            //new Set(relayNameArr).size !== relayNameArr.length
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            }
            let updateBlocksObj = {
                "apartmentId":this.updateBlocks.id,
                // "apartmentName":this.updateBlocks.name,
                // "apartmentNo": this.updateBlocks.number,
                "floorEnable": this.floorEnable,
                "floorQuantity": this.floorQuantity,
                "floorConfig": finFloorConfig,
            }
            // console.log("updateBlocksObj",updateBlocksObj);
            this.updateBlocks.updateBtnState = 1;
            sitesBlocksApi.updateSiteBlocks(rgnObj,updateBlocksObj).then(res => {
                if(res.code === 0){
                    this.updateBlocks.updateBtnState = 0;
                    this.$message.success(this.$t('UpdateSuccessfully'));
                    this.getBlocksDetail();
                }else{
                    this.updateBlocks.updateBtnState = 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.updateBlocks.updateBtnState = 0;
                console.log(err);
            })
        }
    },
    computed:{
        ...mapState(["selectCompany","companyList"])
    },
    watch:{
      
    }
}
</script>

<style scoped>
.liftRelayContent{
    text-align: left;
    padding-top: 20px;
}
.liftRelayItem{
    display: flex;
    align-items: baseline;
    margin-top: 10px;
}
.liftRelayItem label{
    width: 135px;
    margin-right: 20px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.liftRelayItem input{
    width: 300px;
}
.liftRelayItem button{
    margin-left: 10px;
}
.editInput{
    width: 170px;
}
.relayBox{
    text-align: left;
    margin-top: 20px;
    width: calc(100% - 60px);
    padding: 5px 25px 20px;
    background: #F4F4F4;
    border-radius: 8px;
    margin-bottom: 60px;
    
}
.relayBox::after {
    content: "";
    display: block;
    clear:both;
}
.relayItemBox{
    float: left;
}
.relayItemBox label{
    display: inline-block;
    margin-right: 15px;
    width: 80px;
}
.relayItemBox .relayItemInput{
    margin-right: 30px;
    width: 90px;
}

::v-deep .relayItemInput .el-input__inner {
    height: 30px!important;
    line-height: 30px!important;
    border: 1px solid #333;
    background: #fff;
}
.savetBtn{
    background: #6498b5;
    color: #fff;
    font-weight: bold;
    position: fixed;
    left: 50%;
    bottom: 38px;
}
</style>